import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';

import Typography from 'material-ui/Typography';

import TreeNodeModel from 'models/TreeNode';

@observer
export default class NodeSecondaryText extends Component {

  static propTypes = {
    node: PropTypes.instanceOf(TreeNodeModel).isRequired,
    showShorDescription: PropTypes.bool
  }

  static defaultProps = {
    showShorDescription: false
  }

  get isShortDescriptionVisible() {
    const { showShorDescription, node } = this.props;
    return showShorDescription && !!node.shortDescription;
  }

  render() {
    const { node } = this.props;

    return (
      <Fragment>
        <Typography paragraph={ this.isShortDescriptionVisible } >
          { node.description }
        </Typography>
        { this.isShortDescriptionVisible &&
          <Typography>
            { node.shortDescription }
          </Typography>
        }
      </Fragment>
    );
  }

}



// WEBPACK FOOTER //
// ./src/components/list/NodeSecondaryText.js